import axios from "axios"
import { getCookie, delCookie } from "@/utils/cookie"
import { Translate } from "@/utils/utils"
import Vue from "vue"
import locale from "element-ui/lib/locale/lang/en"
import Element from "element-ui"
import { store } from "@/store/store.js"
Vue.use(Element, { locale })

const TIMEOUT = 120000
const TIMEOUT_SHORT = 120000
const TIMEOUT_LONG = 1200000

const basePath = "Base/"
const factoryPath = "Factory/"
const userPath = "User/"
const authPath = "Authority/"
const vendorPath = "Vendor/"
const reservePath = "Reserve/"
const releasePath = "Release/"
const jitPath = "JIT/"
const guardShiftPath = "GuardShift/"
const adminPath = "Admin/"
const JobPath = "Job/"

let unauthorizeAlert = false

const Request = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  header: {
    "Content-Type": "application/json",
  },
  timeout: TIMEOUT,
})

const FileRequest = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  responseType: "blob",
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
  timeout: TIMEOUT,
})

Request.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
    config.headers["Accept-Language"] = sessionStorage.getItem("Accept-Language")
    config.headers["TimeZone"] = new Date().toTimeString().slice(9, 17)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

FileRequest.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
    config.headers["Accept-Language"] = sessionStorage.getItem("Accept-Language")
    config.headers["TimeZone"] = new Date().toTimeString().slice(9, 17)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

Request.interceptors.response.use(
  (response) => {
    sessionStorage.setItem("needUnauthorizeRedirect", "")
    return response
  },
  (error) => {
    //hack:避免request多次導致彈跳多次(暫時解)
    let needUnauthorizeRedirect = sessionStorage.getItem("needUnauthorizeRedirect")
    if (error.response.status == 401 || error.response.status == 403) {
      delCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
      if ((needUnauthorizeRedirect === null || needUnauthorizeRedirect === "") && store.getters.getLogin) {
        let yes = confirm(` ${Translate("pages.wording.tokenIsExpiredPleaseReload")}`)
        if (yes) {
          sessionStorage.setItem("needUnauthorizeRedirect", "true")
          window.location.replace(location.protocol + "//" + location.host)
        }
      }
    }
    return Promise.reject(error)
  }
)

export const RequestToken = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // process.env.VUE_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: TIMEOUT_SHORT,
  withCredentials: true,
})

export const getLDPA = function (data) {
  return RequestToken.post(basePath + "LDPALogin", data)
}
export const getSsoToken = function () {
  return RequestToken.get("https://it-sso.deltaww.com/auth")
}
export const mailService = function (data) {
  return Request.post(reservePath + "UtilsSentMail", data)
}
/***************-BASE-***************/
export const getCodeCultures = function () {
  return Request.get(basePath + "GetCodeCultures")
}
export const getCodeListWithCulture = function (data) {
  return Request.post(basePath + "GetCodeListWithCulture", data)
}
export const getRegion = function (data) {
  return Request.post(basePath + "GetRegion", data)
}
export const getArea = function (data) {
  return Request.post(basePath + "GetArea", data)
}
export const getFactory = function (data) {
  return Request.post(basePath + "GetFactory", data)
}
export const getMultiAreasFactory = function (data) {
  return Request.post(basePath + "GetMultiAreasFactory", data)
}
export const getLocation = function () {
  return Request.get(basePath + "getlocation")
}
export const getCartype = function () {
  return Request.get(basePath + "getcartype")
}
export const getGate = function () {
  return Request.get(basePath + "getgate")
}
export const getRole = function () {
  return Request.get(basePath + "getrole")
}
export const getJob = function () {
  return Request.get(basePath + "getjob")
}
export const getCarColor = function () {
  return Request.get(basePath + "getcarcolor")
}
export const getEnterReason = function () {
  return Request.get(basePath + "getEnterReason")
}
export const getRegionAreaByFactory = function (data) {
  return Request.post(basePath + "GetRegionAreaByFactory", null, data)
}
export const getUserRoleList = function (userNT) {
  return Request.get(basePath + "GetUserRoleList?UserNT=" + userNT)
}
export const getCaptcha = function () {
  return Request.get(basePath + "getCaptcha")
}
/***************-FACTORY MAINTAIN-***************/
export const getLocationByFactory = function (data) {
  return Request.get(factoryPath + "GetLocationByFactory", data)
}
export const addOrUpdateFactoryLocation = function (data) {
  return Request.post(factoryPath + "AddOrUpdateFactoryLocation", data)
}
export const getFactoryLocationTable = function (data) {
  return Request.post(factoryPath + "GetFactoryLocationTable", data)
}
export const deleteFactoryLocation = function (data) {
  return Request.delete(factoryPath + `DeleteFactoryLocation?factoryLocationId=${data.factoryLocationId}`)
}
export const addOrUpdateFactoryCarType = function (data) {
  return Request.post(factoryPath + "AddOrUpdateFactoryCarType", data)
}
export const getFactoryCartypeTable = function (data) {
  return Request.post(factoryPath + "GetGactoryCarTypeTable", data)
}
export const deleteFactoryCartype = function (data) {
  return Request.delete(factoryPath + `DeleteFactoryCartype?id=${data.id}`)
}
export const getGateByCartypeNArea = function (data) {
  return Request.get(vendorPath + "GetGatelistByCartypeNArea", data)
}
/***************-AUTH-***************/
export const searchEmpUser = function (data) {
  return Request.get(userPath + "SearchEmpUser", data)
}
export const getUserInfo = function (data) {
  return Request.get(userPath + "GetUserDetail", data)
}
export const upsertAuth = function (data) {
  return Request.post(authPath + "UpsertAuth", data)
}
export const deleteAuth = function (data) {
  return Request.delete(authPath + "DeleteAuth?userNT=" + data.userNT)
}
export const getAuthTable = function (data) {
  return Request.post(authPath + "getauthtable", data)
}
export const getCurrentUser = function () {
  return Request.get(authPath + "current-user")
}
export const getUserAuthInfo = function (data) {
  return Request.get(authPath + "GetUserAuthInfo", data)
}
export const getGuardRight = function (data) {
  return Request.post(authPath + "GetGuardRight", data)
}
/***************-VENDOR-***************/
export const createVendor = function (data) {
  return Request.post(vendorPath + "AddVendor", data)
}
export const queryOAcodeList = function (data) {
  return Request.get(vendorPath + "GetOACodetop10ByOAcode", data)
}
export const queryOAcodeListWithArea = function (data) {
  return Request.get(vendorPath + "GetOACodeTop10ByOAcodeAndArea", data)
}
export const getVendorTable = function (data) {
  return Request.post(vendorPath + "GetVendorTable", data)
}
export const getVendorInfo = function (data) {
  return Request.post(vendorPath + "GetVendorInfo", null, data)
}
export const upsertVendor = function (data) {
  return Request.post(vendorPath + "UpsertVendor", data)
}
export const getVendorByOACode = function (data) {
  return Request.get(vendorPath + "GetVendorByOACode", data)
}
export const getFactoryByOAcode = function (data) {
  return Request.post(vendorPath + "GetFactoryByOAcode", data)
}

export const getVendorAreaByOACode = function (data) {
  return Request.get(vendorPath + "GetAreaByOAcode", data)
}
export const getVendorFactoryById = function (data) {
  return Request.get(vendorPath + "GetFactoryByVendorId", data)
}
export const disableVendorDriver = function (data) {
  return Request.post(vendorPath + "DisableDriver", null, data)
}
export const disableVendorCar = function (data) {
  return Request.post(vendorPath + "DisableCar", null, data)
}
export const disableVendor = function (data) {
  return Request.post(vendorPath + "DisableVendor", null, data)
}
export const resetVendorPassword = function (data) {
  return Request.post(vendorPath + "ResetVendorPassword", null, data)
}
export const getVendorWithPasswordChage = function (data) {
  return Request.post(vendorPath + "GetVendorWithPasswordChage", null, data)
}
/***************-RESERVE-***************/
export const saveAndSubmitReserveData = function (data) {
  return Request.post(reservePath + "SaveAndSubmitReserveData", data)
}
export const upsertReserveByUser = function (data) {
  return Request.post(reservePath + "UpsertReserve", data)
}
export const getReserveTable = function (data) {
  return Request.post(reservePath + "GetReserveTable", data)
}
export const getReserveIDByParams = function (data) {
  return Request.post(reservePath + "GetReserveIDByParams", null, data)
}
export const getMyReserveTable = function (data) {
  return Request.post(reservePath + "GetMyReserveTable", data)
}
export const getQueryReserveTable = function (data) {
  return Request.post(reservePath + "GetQueryReserveTable", data)
}
export const getExportReserveTable = function (data) {
  return FileRequest.post(reservePath + "GetExportReserveExcel", data)
}
export const getExportInspectHistory = function (data) {
  return FileRequest.post(reservePath + "GetExportInspectHistory", data)
}
export const getReserveInfo = function (data) {
  return Request.post(reservePath + "GetReserveInfo", null, data)
}
export const getReleaseNum = function (data) {
  return Request.post(reservePath + "GetReleaseNumber", null, data)
}
export const getSOTableBindingWithReserve = function (reserveID) {
  return Request.get(reservePath + `GetSoListBindingWithReserveData?ReserveID=${reserveID}`)
}
export const updateReserveFlow = function (data) {
  return Request.put(reservePath + "UpdateReserveFlow", data)
}
export const getReserveCountForGuard = function (data) {
  return Request.post(reservePath + "GetReserveCountForGuard", data)
}
export const getReserveListForGuard = function (data) {
  return Request.post(reservePath + "GetReserveListForGuard", data)
}

/***************-GUARD-***************/
export const upsertInspectByGuard = function (data) {
  return Request.post(reservePath + "UpsertReserveByGuard", data)
}
/***************-RELEASE-***************/
export const getReleaseTable = function (data) {
  return Request.post(releasePath + "GetReleaseTable", data)
}
export const getExportReleaseTable = function (data) {
  return Request.post(releasePath + "GetExportReleaseTable", data)
}
export const saveOrSubmitReleaseData = function (data) {
  return Request.patch(releasePath + "SaveOrSubmitReleaseData", data)
}
export const cancelReleaseData = function (data) {
  return Request.patch(releasePath + "CancelReleaseData", data)
}
export const checkReleaseAllFinishedSign = function (data) {
  return Request.post(releasePath + "CheckReleaseAllFinishedSign", null, data)
}
export const updateRelease = function (data) {
  return Request.post(releasePath + "UpdateRelease", data)
}
export const getReleaseInfo = function (data) {
  return Request.post(releasePath + "GetReleaseInfo", null, data)
}
export const getSOCredit = function (data) {
  return Request.post(releasePath + "GetSOCredit", data)
}
export const updateSO = function (data) {
  return Request.post(releasePath + "UpdateSO", data)
}
export const updateReleaseANSo = function (data) {
  return axios.all([updateRelease(data.updateParams), updateSO(data.soParams)])
}
export const getSignTable = function (data) {
  return Request.post(releasePath + "GetSignTable", data)
}
export const approvalRelease = function (data) {
  return Request.patch(releasePath + "ApprovalRelease", data)
}
export const getReleaseTableWithSign = function (data) {
  return Request.post(releasePath + "GetReleaseTableWithSign", data)
}
export const getApprovalReleaseTableForMobile = function (data) {
  return Request.post(releasePath + "GetReleaseTableForSign", data)
}

export const updateSignList = function (data) {
  return Request.post(releasePath + "UpdateSignList", data)
}
export const updateReleaseANSign = function (data) {
  return axios.all([updateRelease(data.updateParams), updateSignList(data.signListParams)])
}
export const updateReleaseStatus = function (data) {
  return Request.post(releasePath + "UpdateReleaseStatus", null, data)
}
export const getCompanyNameByPlantCode = function (data) {
  return Request.post(releasePath + "GetCompanyNameByPlantCode", null, data)
}
/**************To ERP*****************/
export const postReserveStatusToERP = function (data) {
  return Request.post(releasePath + "PostReserveStatusToERP", null, data)
}
export const updateSoToERP = function (data) {
  return Request.post(releasePath + "UpdateSoToERP", data)
}
export const postReleaseStatusToERP = function (data) {
  return Request.post(releasePath + "PostReleaseStatusToERP", null, data)
}
/**************JIT*****************/
export const getJITList = function (data) {
  return Request.post(jitPath + "GetJITList", data)
}
export const getJITExcelList = function (data) {
  return Request.get(jitPath + "GetJITExcelList?area=" + data)
}
export const addJITData = function (data) {
  return Request.post(jitPath + "AddJITData", data)
}
export const getSameReserveWithDifferentFactory = function (data) {
  return Request.post(jitPath + "GetSameReserveWithDifferentFactory", data)
}
export const disableJITData = function (data) {
  return Request.put(jitPath + "DisableJITData", data)
}
/**************Guard Shift*****************/
export const getGuardShiftList = function (data) {
  return Request.post(guardShiftPath + "GetGuardShiftList", data)
}
export const uploadGuardShift = function (data) {
  return Request.post(guardShiftPath + "UploadGuardShift", data)
}
export const getGuardShiftSampleFile = function () {
  return FileRequest.get(guardShiftPath + "GetGuardShiftSampleFile")
}
/**************Admin*****************/
export const updateSystemSettingValue = function (data) {
  return Request.put(adminPath + "UpdateSystemSettingValue", null, data)
}
export const getSystemSettingValue = function (data) {
  return Request.post(adminPath + "GetSystemSettingValue", null, data)
}
export const updataReserveStatus = function (data) {
  return Request.post(reservePath + "UpdataReserveStatus", null, data)
}
export const updateReleaseStatusByReleaseID = function (data) {
  return Request.post(releasePath + "UpdateReleaseStatusByReleaseID", null, data)
}
export const runJITAutoReserve = function (data) {
  return Request.post(JobPath + "RunJITAutoReserve", null, data)
}
